import { render, staticRenderFns } from "./transferColdWallet.vue?vue&type=template&id=ebe95324&scoped=true&"
import script from "./transferColdWallet.vue?vue&type=script&lang=js&"
export * from "./transferColdWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe95324",
  null
  
)

export default component.exports